"use client";

import {
  Capacitor,
  type PluginListenerHandle,
  registerPlugin,
} from "@capacitor/core";

type HiiveSmsRetrieverPlugin = {
  start(): Promise<void>;
  stop(): Promise<void>;
  addListener(
    eventName: "code",
    listener: (event: { code: string }) => void,
  ): Promise<PluginListenerHandle>;
};

const plugin = registerPlugin<HiiveSmsRetrieverPlugin>("HiiveSmsRetriever");

export function isAndroidSmsRetrieverAvailable(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";
}

/** Best effort: manual code entry remains available when Play services is absent. */
export async function startAndroidSmsRetriever(): Promise<void> {
  if (!isAndroidSmsRetrieverAvailable()) return;
  await plugin.start();
}

export async function stopAndroidSmsRetriever(): Promise<void> {
  if (!isAndroidSmsRetrieverAvailable()) return;
  await plugin.stop();
}

export async function listenForAndroidSmsCode(
  listener: (code: string) => void,
): Promise<PluginListenerHandle | null> {
  if (!isAndroidSmsRetrieverAvailable()) return null;
  return plugin.addListener("code", ({ code }) => listener(code));
}
